import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import MakeContractPanel from '../../../widgets/makeContract/MakeContractPanel'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { getAddAttachmentsContractForm, getBankAccount } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import StampedDocumentWidget from '../../../widgets/contractCenterAddBankAccount/StampedDocumentWidget'

export default function AddAttachmentsContract() {
  //มีคำขอเอกสารเพิ่มเติม (หลังลงนาม)
  const [isEditAll, setIsEditAll] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isEditWidget, setIsEditWidget] = useState({})
  const [BankAccountSchema, setBankAccountSchema] = useState()

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getAddAttachmentsContractForm(projectVersionId)
      setSchema(response.model)

      const bookbank = await getBankAccount(projectVersionId)
      setBankAccountSchema(bookbank.model)
      console.log('bookbank', bookbank)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={6}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

        {schema?.forms?.agreementDetails && (
          <AgreementAdditionalWidgets
            formSchema={schema.forms.agreementDetails}
            preContentLabel={'ข้อคิดเห็นจากศูนย์สัญญา : '}
          />
        )}

        {schema?.forms?.forms && (
          <MakeContractPanel
            showCommandButton={!schema?.forms?.attachmentGrantee?.disabled}
            isEdit={isEditWidget.attachment}
            schema={schema.forms.forms}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('attachment', _isEdit, setIsEditWidget)
            }
            isAddAtttachmentsOnly={true}
            bankAccountSchema={BankAccountSchema.forms}
            requestDocText={
              schema?.forms?.agreementDetails?.content
                ? 'ข้อคิดเห็นจากศูนย์สัญญา : ' + schema?.forms?.agreementDetails?.content
                : ''
            }
          />
        )}
        <br />

        <StampedDocumentWidget />
      </SidebarProposal>
    </>
  )
}
